import { Skeleton } from "@mui/material";
import classNames from "classnames";
import styles from "../table.module.scss";

interface PlanHistoryTableSkeletonProps {
  count?: number;
  className?: string;
}

const COLUMNS = [
  "Plan",
  "Duration",
  "Plan price",
  "Discounted price",
  "Plan status",
  "Start date",
  "End date",
  "Actions",
];

/** Same eight columns and two row actions as the loaded plan history. */
function PlanHistoryTableSkeleton({
  count = 3,
  className,
}: PlanHistoryTableSkeletonProps) {
  return (
    <div className={classNames(styles.card, className)}>
      <div className={styles.heading}>
        <Skeleton variant="text" width={130} height={28} />
      </div>
      <div className={styles.scroll}>
        <table className={styles.table}>
          <thead>
            <tr>
              {COLUMNS.map((column) => (
                <th key={column} className={styles.th}>
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: count }).map((_, index) => (
              <tr key={index}>
                <td className={styles.td}>
                  <Skeleton variant="text" width={186} height={20} />
                </td>
                <td className={styles.td}>
                  <Skeleton variant="text" width={68} height={20} />
                </td>
                <td className={styles.td}>
                  <Skeleton variant="text" width={92} height={20} />
                </td>
                <td className={styles.td}>
                  <Skeleton variant="text" width={92} height={20} />
                </td>
                <td className={styles.td}>
                  <Skeleton
                    variant="rounded"
                    width={70}
                    height={22}
                    sx={{ borderRadius: "16px" }}
                  />
                </td>
                <td className={styles.td}>
                  <Skeleton variant="text" width={88} height={20} />
                </td>
                <td className={styles.td}>
                  <Skeleton variant="text" width={88} height={20} />
                </td>
                <td className={styles.td}>
                  <div className={styles.actions}>
                    <Skeleton variant="circular" width={32} height={32} />
                    <Skeleton variant="circular" width={32} height={32} />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default PlanHistoryTableSkeleton;
